import DetailStoreSection from './DetailStoreSection';

export default DetailStoreSection;
